import React, { useContext, useEffect, useState } from "react";
import { FormikErrors, FormikTouched, FormikValues } from "formik";
import SizeBox from "../../../../../components/SizeBox";
import { LocalizationContext } from "../../../../../locales/Translation";
import DropdownSearchAndPaging from "../../../../../components/DropdownSearchAndPaging";
import { useDispatch, useSelector } from "react-redux";
import { timeZoneListSelector } from "../../../selectors/PropertySelector";
import { getTimeZoneListThunk } from "../../../thunks/PropertyThunks";
type Props = {
  values: FormikValues;
  errors: FormikErrors<FormikValues>;
  touched: FormikTouched<FormikValues>;
  setFieldValue: any;
};
const Timezone = ({ values, errors, touched, setFieldValue }: Props) => {
  const { translations } = useContext(LocalizationContext);

  const dispatch = useDispatch();
  const timeZoneList = useSelector(timeZoneListSelector);

  useEffect(() => {
    dispatch<any>(getTimeZoneListThunk({}));
  }, [dispatch]);
  const timezoneOptions = Object.entries(timeZoneList).map(([key, value]) => ({
    key,
    text: value || "No timezone",
    value,
  }));
  const handleChange = (event: any, { value }: any) => {
    setFieldValue("timezone", value);
  };
  return (
    <div className={"section"}>
      <SizeBox height={"16px"} />
      <div className={"section-title"}>
        Timezone
        {/*{translations.Timezone}*/}
      </div>
      <div style={{ width: "100%", marginTop: -20 }}>
        <DropdownSearchAndPaging
          placeholder={"Select a timezone"}
          options={timezoneOptions}
          value={values.timezone}
          onChange={handleChange}
          listCompanyRaw={timeZoneList}
          selectUI={true}
          clearable={true}
        />
      </div>
      <SizeBox height={"16px"} />
    </div>
  );
};

export default Timezone;
